export const ADD_TRANSLATIONS = 'ADD_TRANSLATIONS';
export const CLEAR_TRANSLATIONS = 'CLEAR_TRANSLATIONS';
export const SET_DEFAULT_TRANSLATIONS = 'SET_DEFAULT_TRANSLATIONS';
export const SHOW_TRANSLATION_KEYS = 'SHOW_TRANSLATION_KEYS';

export const addTranslationsAction = translations => ({
    type: ADD_TRANSLATIONS,
    payload: { translations }
});

export const clearTranslationsAction = () => ({
    type: CLEAR_TRANSLATIONS
});

export const setDefaultTranslationsAction = defaultTranslations => ({
    type: SET_DEFAULT_TRANSLATIONS,
    payload: { defaultTranslations }
});

export const showTranslationKeysAction = (show = true) => ({
    type: SHOW_TRANSLATION_KEYS,
    payload: show
});
